import styled from '@emotion/styled';
import { useRouter } from 'next/router';

// components
import Button from '@components/_atoms/Button';
import Modal from '@components/_atoms/Modal';
import Typography from '@components/_atoms/Typography';

// constants
import { ButtonColor, TypoVariant } from '@constants/atoms';
import { gray, red } from '@styles/Colors';
import { RefObject } from 'react';
import { useTranslation } from 'next-i18next';
import ButtonCode from '@constants/log/buttonCode';

type Props = {
  openModal: boolean;
  modalRef: RefObject<HTMLElement>;
  handleModalClose: () => void;
  handleFormSubmit: () => void;
  isLoading?: boolean;
};

const Content = styled.div`
  display: grid;
  row-gap: 16px;
`;

const HighLightRed = styled.span`
  color: ${red.red3};
`;

const ButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
`;

export default function SubmitModal({ openModal, modalRef, handleModalClose, handleFormSubmit, isLoading }: Props) {
  const { t, i18n } = useTranslation('component');
  const ko = i18n.language === 'ko';
  return (
    <Modal
      modalRef={modalRef}
      width="400px"
      open={openModal}
      title={t('submitModal.title')}
      handleModalClose={handleModalClose}>
      <Content>
        <Typography variant={TypoVariant.B4} color={gray.gray7}>
          {ko ? (
            <>
              한 번 견적을 제출하면 <HighLightRed>수정할 수 없어요!</HighLightRed>
              <br />
              견적을 제출할까요?
            </>
          ) : (
            <>Once you submitted a quotation, it cannot be edited. Do you want to submit now?</>
          )}
        </Typography>
        <ButtonWrapper>
          <Button
            color={ButtonColor.OutlinedGray}
            text={t('submitModal.button1')}
            onClick={handleModalClose}
            steelbosoId={ButtonCode.BTN_CANCEL}
          />
          <Button
            text={t('submitModal.button2')}
            onClick={handleFormSubmit}
            isLoading={isLoading}
            steelbosoId={ButtonCode.BTN_SUBMIT}
          />
        </ButtonWrapper>
      </Content>
    </Modal>
  );
}
